<template>
  <div>
    <section v-show="!loader" class="hl_login">
      <div class="hl_login--header">
        <div
          class="container-fluid"
          style="min-height: 28px; display: flex; justify-content: space-between; align-items: center"
        >
          <a href="./" :aria-label="$t('common.goToHomepage')">
            <svg v-if="logoURL === 'default'" xmlns="http://www.w3.org/2000/svg" width="28" height="26" aria-hidden="true">
              <image
                width="28"
                height="26"
                xlink:href="data:img/png;base64,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"
              ></image>
            </svg>
            <img
              v-else-if="logoURL === 'leadconnectorhq'"
              width="28"
              height="26"
              src="https://storage.googleapis.com/highlevel-staging.appspot.com/assets/static/img/leadconnectorhq.png"
              :alt="$t('common.leadConnectorHqLogo')"
            />
            <img v-else-if="logoURL" style="max-height: 75px" :src="logoURL" :alt="$t('common.companyLogo')" />
          </a>
          <LanguageDropdown @update-selected-language="handleLanguageUpdate" />
        </div>
      </div>
      <div class="hl_login--body">
        <div class="container-fluid">
          <div class="card" v-if="!isOtpScreen">
            <div class="card-body">
              <div class="login-card-heading">
                <h2 class="heading2">{{ $t('login.signInAccount') }}</h2>
                <h4 class="h6" style="color: #000; font-weight: bold" v-show="resetPasswordMsg">
                  {{ $t('login.resetPasswordMsg') }}
                </h4>
                <div
                  class="flex relative items-center p-2 text-gray-400 rounded hl-inactive-msg"
                  v-if="inactivityLogoutMsg"
                >
                  <span class="pt-1">
                    {{ $t('campaign.regulatoryBundle.auth.login.inactivityMsg') }}
                  </span>
                  <!-- Close Button -->
                  <button
                    id="inativivty-btn-close"
                    class="rounded-full hover:bg-white/60 align-self-start"
                    @click="forceCloseInactivityAlert"
                  >
                    <XCloseIcon class="w-4 h-4" />
                  </button>
                </div>
              </div>

              <Form
                v-if="!hideOtherLoginOptions"
                ref="formRef"
                @submit="handleFormChange"
                :validation-schema="validationSchema"
                :initial-values="{
                  email: email,
                  password: password,
                }"
              >
                <Field name="email" v-slot="{ field, errorMessage, handleChange, handleBlur }">
                  <div class="form-group">
                    <UITextInputGroup
                      id="email"
                      type="text"
                      :label="$t('login.email')"
                      name="email"
                      :placeholder="$t('login.emailPlaceholder')"
                      :error="!!errorMessage"
                      :errorMsg="errorMessage"
                      :ignoreLastPass="false"
                      :disabled="loading"
                      @blur="handleBlur"
                      @update:modelValue="handleChange"
                      :modelValue="field.value"
                    />
                  </div>
                </Field>

                <Field name="password" v-slot="{ field, errorMessage, handleChange, handleBlur }">
                  <div class="form-group">
                    <UITextInputGroup
                      id="password"
                      name="password"
                      :label="$t('login.password')"
                      type="password"
                      :placeholder="$t('login.passwordPlaceholder')"
                      :error="!!errorMessage"
                      :errorMsg="errorMessage"
                      :ignoreLastPass="false"
                      :disabled="loading"
                      :showPasswordToggle="true"
                      @blur="handleBlur"
                      @update:modelValue="handleChange"
                      :modelValue="field.value"
                    />
                    <router-link
                      v-if="shouldShowForgotPassword()"
                      id="forgot_passowrd_btn"
                      class="font-semibold forgot-password text-curious-blue-500 hover:text-curious-blue-800"
                      :to="{
                        name: 'forgot_password',
                        query: { email: email.trim() },
                      }"
                      >{{ $t('login.forgetPassword') }}</router-link
                    >
                  </div>
                </Field>

                <div class="form-group button-holder">
                  <LoginUIAlert v-if="response" type="danger">
                    {{ response }}
                  </LoginUIAlert>
                  <div style="display: inline-block; position: relative; width: 100%">
                    <UIButton
                      use="tertiary"
                      type="submit"
                      :loading="loading"
                      :disabled="loading"
                      class="justify-center w-full"
                    >
                      {{ loading ? $t('login.verifying') : $t('login.signIn') }}
                    </UIButton>
                  </div>
                </div>
              </Form>

              <div
                class="mt-6"
                v-if="
                  (isLoginWithGoogleAllowed || isLoginWithSSOAllowed || isWhiteLabelLoginWithGoogleAllowed) &&
                  !hideOtherLoginOptions
                "
              >
                <div class="relative">
                  <div class="flex absolute inset-0 items-center">
                    <div class="w-full border-t border-gray-300"></div>
                  </div>
                  <div class="relative flex justify-center text-sm">
                    <span class="px-2 text-gray-500 bg-white">
                      {{ $t('login.or') }} {{ $t('login.continueWith') }}
                    </span>
                  </div>
                </div>
              </div>

              <div v-if="!hideOtherLoginOptions" class="mt-3 button-holder">
                <div id="g_id_signin" class="g_id_signin" data-width="370"></div>
              </div>

              <UIButton
                id="wl_google_login_button"
                type="button"
                use="outline"
                class="flex justify-center items-center mt-3 w-full"
                @click="handleWhiteLabelGoogleLogin()"
                v-if="isWhiteLabelLoginWithGoogleAllowed && !hideOtherLoginOptions"
              >
                <div class="icon-google3 mr-2"></div>
                {{ $t('campaign.regulatoryBundle.auth.login.signInWithGoogle') }}
              </UIButton>
              <UIButton
                id="sso_login_button"
                type="button"
                :use="hideOtherLoginOptions ? 'tertiary' : 'outline'"
                class="justify-center mt-3 w-full"
                @click="handleLoginWithSSO()"
                v-if="isLoginWithSSOAllowed"
              >
                {{ $t('login.signInWithSSO') }}
              </UIButton>
              <p
                class="foot-note"
                v-if="!hideTermsAndConditions"
                v-html="$t('campaign.regulatoryBundle.auth.sso.agreeTerms', { termsConditionsURL })"
              ></p>
            </div>
          </div>
          <LoginOTPScreen
            v-else
            :email="email"
            :password="password"
            :emailMask="emailMask"
            :phoneMask="phoneMask"
            :totpEnabled="totpEnabled"
            :selectedCompanyId="selectedCompanyId"
          />
        </div>
      </div>
    </section>

    <MultipleUsersLogin
      v-if="multipleUsersFound"
      :values="multipleUsersFound"
      @hidden="multipleUsersFound = null"
      @submit="selectAgencyMultipleUser"
    />
  </div>
</template>

<script setup lang="ts">
import { onMounted, onBeforeMount, computed, ref } from 'vue'

import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { getHostAndDomain } from '../../util/helper'
import { OauthService } from '@/services'
import config from '@/config'
import { handleSuccessfulLogin, handleLoginError } from '../utils/LoginHelper'
import LoginOTPScreen from './LoginOTPScreen.vue'
import LoginUIAlert from '../components/LoginUIAlert.vue'
import MultipleUsersLogin from '../components/MultipleUsersLogin.vue'
import XCloseIcon from './reporting/notification/XCloseIcon.vue'
import LanguageDropdown from '../components/login/languageDropdown.vue'
import { Form, Field } from 'vee-validate'
import * as yup from 'yup'
import CompanyService from '../../services/CompanyService'
import allowedAgenciesForSSO from '../utils/SSOAgencyList'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

// Define validation schema using Yup as a computed property
// This ensures it re-evaluates when translations are loaded from the backend
// The locale is tracked to ensure reactivity when translations are loaded
const validationSchema = computed(() => {
  return yup.object({
    email: yup.string().required(t('login.emailRequired')).email(t('login.invalidEmail')),
    password: yup.string().required(t('login.passwordRequired')),
  })
})

// Define Google Global type
declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (config: any) => void
          renderButton: (element: HTMLElement | null, options: any) => void
          prompt: () => void
        }
      }
    }
  }
}

// Router and store setup
const router = useRouter()
const route = useRoute()
const store = useStore()
const formRef = ref<any>(null)
// Reactive state
const response = ref('')
const email = ref('')
const password = ref('')
const loading = ref(false)
const logoURL = ref('')
const privacyURL = ref('')
const termsConditionsURL = ref('')
const domainCompanyId = ref(null)
const multipleUsersFound = ref<any[] | null>(null)
const resetPasswordMsg = ref(false)
const googleAuth = ref(undefined)
const emailMask = ref('')
const phoneMask = ref('')
const isOtpScreen = ref(false)
const selectedCompanyId = ref('')
const isLoginWithGoogleAllowed = ref(false)
const loader = ref(false)
const isLoginWithSSOAllowed = ref(false)
const hideOtherLoginOptions = ref(false)
const isCannyLogin = ref(false)
const cannyRedirectUrl = ref('')
const cannyCompanyId = ref('')
const isWhiteLabelLoginWithGoogleAllowed = ref(false)
const totpEnabled = ref(false)
const hideTermsAndConditions = ref(false)

// Computed state
const inactivityLogoutMsg = computed(() => {
  return store.getters['auth/isInactivityLogout']
})

// Methods
const fetchBrandData = async () => {
  try {
    const hostDomainInfo = getHostAndDomain()
    const response = await CompanyService.getBranding(hostDomainInfo.domain)
    if (response.info) {
      setBrandData(response.info)
    } else {
      setDefaultBrandData()
    }
  } catch (error) {
    setDefaultBrandData()
  } finally {
    finalizeBrandDataLoading()
  }
}

const setBrandData = (data: any) => {
  logoURL.value = data.logoURL
  const domain = getHostAndDomain()?.domain
  hideTermsAndConditions.value = !!domain?.includes('leadconnectorhq')
  if (domain?.includes('leadconnectorhq')) {
    logoURL.value = 'leadconnectorhq'
  }
  if (logoURL.value) {
    document.querySelector('link[rel="icon"]')?.setAttribute('href', logoURL.value)
  }
  privacyURL.value = data.privacyURL || ''
  termsConditionsURL.value = data.termsConditionsURL || data.privacyURL || ''
  domainCompanyId.value = data.companyId
  applyCustomCSS(data.customCSS)
  applyTheme(data.theme)
  isLoginWithSSOAllowed.value = data?.ssoSettings?.enabled ?? false
  hideOtherLoginOptions.value = (data?.ssoSettings?.enabled && data?.ssoSettings?.hideOtherLoginOptions) ?? false
  isWhiteLabelLoginWithGoogleAllowed.value = data.whitelabelLoginConfig?.isGoogleLoginEnabled
}

const setDefaultBrandData = () => {
  const domain = getHostAndDomain()?.domain
  isLoginWithSSOAllowed.value = domain?.includes('localhost')
  hideTermsAndConditions.value = !!domain?.includes('leadconnectorhq')
  logoURL.value = domain?.includes('leadconnectorhq') ? 'leadconnectorhq' : 'default'
  privacyURL.value = 'https://www.gohighlevel.com/privacy'
  termsConditionsURL.value = 'https://www.gohighlevel.com/terms-of-service'
}

const finalizeBrandDataLoading = () => {
  document.getElementById('app')?.classList.remove('loading')
  store.commit('setAgencyLoaderState', false)
  loader.value = false
}

const applyCustomCSS = (customCSS: string) => {
  if (customCSS) {
    const style = document.createElement('style')
    style.type = 'text/css'
    style.media = 'screen'
    style.appendChild(document.createTextNode(customCSS))
    document.head.appendChild(style)
  }
}

const applyTheme = (theme: string) => {
  if (theme) {
    document.body.dataset.theme = theme
  }
}

const initializeLoginPage = async () => {
  isOtpScreen.value = false
  isCannyLogin.value = route.query?.app === 'canny'
  if (isCannyLogin.value) {
    cannyRedirectUrl.value = route.query?.redirect as string
    cannyCompanyId.value = route.query?.companyID as string
  }

  if (['dev', 'staging'].includes(config.mode) || getHostAndDomain()?.domain?.includes('gohighlevel')) {
    checkAndInitGoogleLogin()
  }

  if (route.query?.email) {
    email.value = route.query?.email as string
    formRef.value?.setFieldValue('email', email.value)
  }
  if (route.query?.reset_password) {
    resetPasswordMsg.value = !!route.query?.reset_password
  }

  // Handle whitelabel google login
  const googleAuthData: any = router.currentRoute.value?.query?.googleAuth
  if (googleAuthData) {
    // remove googleAuth and type from the query
    router.replace('/')
    const decodedGoogleAuthData = atob(googleAuthData)
    const parsedGoogleAuthData = JSON.parse(decodedGoogleAuthData)
    await submit(undefined, undefined, parsedGoogleAuthData)
  }
}

const forceCloseInactivityAlert = () => {
  store.commit('auth/updateInactivityLogout', false)
}

const checkAndInitGoogleLogin = (interval = 1) => {
  if (window.google && window.google.accounts) {
    googleLoginInit()
  } else {
    setTimeout(() => checkAndInitGoogleLogin(interval + 1), interval * 500)
  }
}

const googleLoginInit = (locale: string = 'en') => {
  if (!window.google?.accounts) return

  window.google.accounts.id.initialize({
    client_id: config.googleAuthId,
    callback: (params: any) => submit(undefined, undefined, params),
    locale: locale,
  })

  window.google.accounts.id.renderButton(document.getElementById('g_id_signin'), {
    theme: 'outline',
    size: 'large',
    width: 370,
    locale: locale,
  })

  window.google.accounts.id.prompt()
  isLoginWithGoogleAllowed.value = true
}

const handleFormChange = (values: any) => {
  submit(values, undefined, undefined)
}

const submit = async (values: any = {}, selectedAgencyMultipleUsers?: string, googleAuthData?: any) => {
  try {
    // Handle form data from VeeValidate
    if (values && typeof values === 'object' && !selectedAgencyMultipleUsers) {
      // Update reactive state with form values
      email.value = values.email || email.value
      password.value = values.password || password.value
    }

    // Handle multiple users selection
    if (selectedAgencyMultipleUsers && googleAuth.value) {
      googleAuthData = googleAuth.value
    }
    googleAuth.value = googleAuthData

    loading.value = true
    response.value = ''

    const params = {
      ...getHostAndDomain(),
      email: email.value.trim(),
      password: password.value.trim(),
      deviceId: await store.dispatch('getDeviceId'),
      deviceType: 'web',
      deviceName: navigator.userAgent,
      token: googleAuthData?.credential,
    } as { [key: string]: any }

    selectedCompanyId.value = ''
    if (domainCompanyId.value && domainCompanyId.value !== 'YuTUZlUtrwBtvmgByZDW') {
      params.companyId = domainCompanyId.value
      selectedCompanyId.value = domainCompanyId.value
    } else if (selectedAgencyMultipleUsers) {
      params.companyId = selectedAgencyMultipleUsers
      selectedCompanyId.value = selectedAgencyMultipleUsers
    }

    if (googleAuthData) {
      // Remove properties that would cause errors with Google login
      delete params.domain
      delete params.subdomain
      delete params.email
      delete params.password
      params.isWLGoogleLogin = isWhiteLabelLoginWithGoogleAllowed.value
    }
    const loginResponse = await OauthService.loginWithEmail(params, googleAuthData ? 'google' : 'email')

    if (loginResponse.multipleUsers) {
      multipleUsersFound.value = loginResponse.multipleUsers
      return
    }

    if (!googleAuthData && !loginResponse.token) {
      handleOtpScreen(loginResponse)
      return
    }

    await handleSuccessfulLogin(loginResponse, store, router)
  } catch (error) {
    const { errorMessage } = handleLoginError(error, email.value)
    response.value = errorMessage
  } finally {
    loading.value = false
  }
}

const handleOtpScreen = (response: any) => {
  emailMask.value = response.email
  phoneMask.value = response.phone
  totpEnabled.value = response.totpEnabled
  isOtpScreen.value = true
}

const selectAgencyMultipleUser = async (selectedAgencyMultipleUsers: string) => {
  multipleUsersFound.value = null
  await submit(undefined, selectedAgencyMultipleUsers)
}

const shouldShowForgotPassword = () => {
  return !(router.currentRoute.value.query?.src === 'marketplace')
}

const handleLoginWithSSO = () => {
  // get the url from the query and add to the url
  const url = route.query.url
  if (url) {
    router.push({
      name: 'login_sso',
      query: { url: decodeURIComponent(url as string) },
    })
  } else {
    router.push({ name: 'login_sso' })
  }
}

const handleWhiteLabelGoogleLogin = () => {
  let url = `https://login.leadconnectorhq.com/google?origin=${window.location.origin}`
  if (config.mode != 'production') {
    url = `https://login-staging.leadconnectorhq.com/google?origin=${window.location.origin}`
  }
  window.open(url, '_self')
}

const handleLanguageUpdate = (locale: string) => {
  // Only initialize Google login if in dev, staging, interop, or gohighlevel domain
  if (['dev', 'staging', 'interop'].includes(config.mode) || getHostAndDomain()?.domain?.includes('gohighlevel')) {
    // Handle language update if needed
    const existingScript = document.querySelector('script[src*="gsi/client"]')
    if (existingScript) {
      existingScript.remove()
    }
    const script = document.createElement('script')
    script.src = `https://accounts.google.com/gsi/client?hl=${locale}`
    script.async = true
    script.defer = true
    script.onload = () => {
      // Wait for the script to fully load before initializing
      checkAndInitGoogleLoginWithLocale(locale as string)
    }
    document.head.appendChild(script)
  }
}

const checkAndInitGoogleLoginWithLocale = (locale: string = 'en', interval = 1) => {
  if (window.google && window.google.accounts) {
    googleLoginInit(locale)
  } else {
    setTimeout(() => checkAndInitGoogleLoginWithLocale(locale, interval + 1), interval * 500)
  }
}

// Lifecycle hooks
onBeforeMount(() => {
  if ((window as any).isElectron) {
    ;(window as any).electronAPI.logout()
  }
  loader.value = true
})

onMounted(() => {
  // Added this to fetch brand data before initializing login page since WL google login is not working without it
  fetchBrandData().then(() => {
    initializeLoginPage()
  })
})

// Define metadata
defineOptions({
  name: 'LoginWithEmail',
  metaInfo: {
    title: 'Login',
  },
})
</script>

<style scoped>
.error {
  color: #a94442;
}

.hl_login--body .spinner {
  display: inline-block;
  margin: 40px 0px 0px 0px;
  width: 100%;
}

.has-error .form-control,
.has-error .form-control:focus {
  -webkit-box-shadow: none;
  box-shadow: none;
}

.global-error {
  margin-bottom: 10px;
}

.hl_login--body .v-spinner .v-moon1 {
  margin: auto;
}

.hl-inactive-msg {
  background-color: #fffaeb;
  border: 1px solid #fedf89;
  text-align: start;
  color: #667085;
}
</style>
